import { Button, Typography } from "@mui/material";
import { useListContext, useResourceContext, useResourceDefinition } from "react-admin";

export function EmptyState(props: {
  image?: React.ReactElement;
  noEntriesText?: string;
  noMatchingEntriesText?: string;
}) {
  const { image, noEntriesText, noMatchingEntriesText } = props;
  const resource = useResourceContext();
  const resourceDefinition = useResourceDefinition({ resource });
  const resourceOptions = resourceDefinition.options;
  const { filterValues, setFilters } = useListContext();
  const isFilterActive = Object.keys(filterValues ?? {}).length > 0;
  return (
    <div className="RaList-main">
      <div style={{ textAlign: "center", flex: 1, padding: "40px 0" }}>
        {!isFilterActive && (image ?? <img src="/empty-state.webp" alt="" style={{ maxWidth: "240px", opacity: 1 }} />)}
        <div style={{ opacity: 0.5 }}>
          <Typography>
            {isFilterActive
              ? noMatchingEntriesText || resourceOptions?.noMatchingEntriesText || "Keine passenden Einträge gefunden."
              : noEntriesText || resourceOptions?.noEntriesText || "Noch keine Einträge hinterlegt."}
          </Typography>
        </div>
        {isFilterActive && (
          <Button sx={{ my: "20px " }} variant="outlined" onClick={() => setFilters({}, {}, false)}>
            Filter zurücksetzen
          </Button>
        )}
      </div>
    </div>
  );
}
